const elements = {
	bookingLink: document.querySelector("#navbar .book-link"),
	menuOverlay: document.querySelector("#menu-overlay"),
	navMenuToggles: Array.from(document.querySelectorAll(".nav-menu-toggle")),
	navMenu: document.querySelector("#nav-menu"),
};

const toggleMenu = () => {
	const ariaExpanded = elements.navMenu.getAttribute("aria-expanded");
	elements.menuOverlay.classList.toggle("menu-exited", ariaExpanded === "true");
	if (ariaExpanded === "false") {
		elements.navMenu.setAttribute("aria-expanded", "true");
		elements.bookingLink && elements.bookingLink.classList.add("menu-open");
		document.body.classList.add("no-scroll");
		return;
	}
	document.body.classList.remove("no-scroll");
	elements.bookingLink && elements.bookingLink.classList.remove("menu-open");
	elements.navMenu.setAttribute("aria-expanded", "false");
};

elements.navMenuToggles &&
	elements.navMenuToggles.map((navMenuToggle) => {
		navMenuToggle.addEventListener("click", toggleMenu);
	});
